// extracted by mini-css-extract-plugin
export default {"deptTreeSelectFormItem":"src-pages-staff-components-EditStaffModal-module_deptTreeSelectFormItem--PI3Vy"};